import React, { useEffect, useState } from 'react';
import Home from './Home';
import Services from './Services';

// Simple router switch based on window.location.pathname
const RouterSwitch: React.FC = () => {
  const [path, setPath] = useState(window.location.pathname);

  useEffect(() => {
    const onPopState = () => setPath(window.location.pathname);
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, []);

  if (path === '/' || path === '/index.html') {
    return <Home />;
  }
  if (path === '/services') {
    return <Services />;
  }
  // Add more routes here as needed
  return <div style={{padding: '2rem'}}><h2>Page not found</h2></div>;
};

export default RouterSwitch;
